<template>
    <div class="catalog-card-container">
        <slot />
    </div>
</template>

<style scoped>
.catalog-card-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3vw;
    margin-top: -26vw;
}
</style>